import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './component3cards.css'

const Component3cards = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const TitleTag = props.titleAs
  return (
    <div
      className={`component3cards-thq-layout251-elm ${props.rootClassName} `}
    >
      <div className="component3cards-thq-header-component-elm thq-flex-column">
        {props.showBigTitle === true && (
          <TitleTag className="component3cards-thq-component-title1-elm H1_large">
            {props.componentTitle}
          </TitleTag>
        )}
        {props.showBigTitle === true && (
          <span className="component3cards-thq-component-text1-elm H1_small">
            {props.componentText}
          </span>
        )}
        {props.showBigTitle === false && (
          <TitleTag className="component3cards-thq-component-title2-elm H1_small">
            {props.componentTitle}
          </TitleTag>
        )}
        {props.showBigTitle === false && (
          <span className="component3cards-thq-component-text2-elm">
            {props.componentText}
          </span>
        )}
      </div>
      <div className="component3cards-thq-main-content-elm">
        <a
          href={
            typeof props.feature1Url === 'string'
              ? props.feature1Url
              : props.feature1Url?.['url']
          }
          target={props.feature1Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature1Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component3cards-prop-link1"
        >
          <div className="component3cards-thq-feature1-elm thq-flex-column">
            <img
              alt={props.feature1ImageAlt}
              src={props.feature1ImageSrc}
              loading="lazy"
              className="component3cards-thq-feature1-image-elm thq-img-ratio-4-3"
            />
            <div className="component3cards-thq-content-elm1">
              <h3 className="component3cards-thq-feature1-title-elm1">
                {props.feature1Title}
              </h3>
              {props.showFeature1Title === true && (
                <h3>
                  {props.feature1Title2 ?? (
                    <Fragment>
                      <span className="component3cards-text6">
                        feature1Title
                      </span>
                    </Fragment>
                  )}
                </h3>
              )}
              <span className="component3cards-thq-feature1-description-elm thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="component3cards-text5">
                      feature1Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature2Url === 'string'
              ? props.feature2Url
              : props.feature2Url?.['url']
          }
          target={props.feature2Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature2Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component3cards-prop-link2"
        >
          <div className="component3cards-thq-feature2-elm thq-flex-column">
            <img
              alt={props.feature2ImageAlt}
              src={props.feature2ImageSrc}
              loading="lazy"
              className="component3cards-thq-feature2-image-elm thq-img-ratio-4-3"
            />
            <div className="component3cards-thq-content-elm2">
              <h3 className="component3cards-thq-feature2-title-elm1">
                {props.feature2Title2 ?? (
                  <Fragment>
                    <span className="component3cards-text2">feature2Title</span>
                  </Fragment>
                )}
              </h3>
              {props.showFeature2Title === true && (
                <h3 className="component3cards-thq-feature2-title-elm2 H1_extrasmall">
                  {props.feature2Title1}
                </h3>
              )}
              <span className="component3cards-thq-feature2-description-elm thq-body-small">
                {props.feature2Description1 ?? (
                  <Fragment>
                    <span className="component3cards-text1">
                      feature2Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature3Url === 'string'
              ? props.feature3Url
              : props.feature3Url?.['url']
          }
          target={props.feature3Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature3Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component3cards-prop-link3"
        >
          <div className="component3cards-thq-feature3-elm thq-flex-column">
            <img
              alt={props.feature3ImageAlt}
              src={props.feature3ImageSrc}
              loading="lazy"
              className="component3cards-thq-feature3-image-elm thq-img-ratio-4-3"
            />
            <div className="component3cards-thq-content-elm3">
              <h3 className="component3cards-thq-feature3-title-elm1">
                {props.feature3Title2 ?? (
                  <Fragment>
                    <span className="component3cards-text3">feature3Title</span>
                  </Fragment>
                )}
              </h3>
              {props.showFeature3Title === true && (
                <h3 className="component3cards-thq-feature3-title-elm2 H1_extrasmall">
                  {props.feature3Title1}
                </h3>
              )}
              <span className="component3cards-thq-feature3-description-elm thq-body-small">
                {props.feature3Description1 ?? (
                  <Fragment>
                    <span className="component3cards-text4">
                      feature3Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  )
}

Component3cards.defaultProps = {
  componentTitle: 'componentTitle',
  showFeature2Title: false,
  showFeature3Title: false,
  feature2Description1: undefined,
  feature3ImageSrc: 'feature3ImageSrc',
  feature2Title2: undefined,
  feature3Title2: undefined,
  showFeature1Title: false,
  feature1Title: 'feature1Title',
  rootClassName: '',
  feature1ImageSrc: 'feature1Image',
  feature2Url: {
    url: '',
    newTab: false,
  },
  feature3Description1: undefined,
  componentText: 'componentText',
  feature3Title1: 'feature3Title',
  feature3Url: {
    url: '',
    newTab: false,
  },
  showBigTitle: true,
  feature1Description: undefined,
  feature1Url: {
    url: '',
    newTab: false,
  },
  feature2ImageSrc: 'feature2ImageSrc',
  feature1ImageAlt: '',
  feature2ImageAlt: '',
  feature3ImageAlt: '',
  titleAs: 'h2',
  feature1Title2: undefined,
  feature2Title1: 'feature2Title',
}

Component3cards.propTypes = {
  componentTitle: PropTypes.string,
  showFeature2Title: PropTypes.bool,
  showFeature3Title: PropTypes.bool,
  feature2Description1: PropTypes.element,
  feature3ImageSrc: PropTypes.string,
  feature2Title2: PropTypes.element,
  feature3Title2: PropTypes.element,
  showFeature1Title: PropTypes.bool,
  feature1Title: PropTypes.string,
  rootClassName: PropTypes.string,
  feature1ImageSrc: PropTypes.string,
  feature2Url: PropTypes.object,
  feature3Description1: PropTypes.element,
  componentText: PropTypes.string,
  feature3Title1: PropTypes.string,
  feature3Url: PropTypes.object,
  showBigTitle: PropTypes.bool,
  feature1Description: PropTypes.element,
  feature1Url: PropTypes.object,
  feature2ImageSrc: PropTypes.string,
  feature1ImageAlt: PropTypes.string,
  feature2ImageAlt: PropTypes.string,
  feature3ImageAlt: PropTypes.string,
  titleAs: PropTypes.string,
  feature1Title2: PropTypes.element,
  feature2Title1: PropTypes.string,
}

export default Component3cards
